/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { MissingTranslationHandler, TranslateModule, TranslateService } from '@ngx-translate/core';
import { APP_BASE_HREF } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, ErrorHandler, Injector, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JWT_OPTIONS, JwtModule, JwtHelperService } from '@auth0/angular-jwt';
import { CookieService } from 'ngx-cookie-service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenComponent } from './pages/token/token.component';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthInterceptor } from './services/auth-interceptor.service';
import { ConfigStoreService } from './services/config-store.service';
import { MenuService } from './services/menu.service';
import { NavigationDataMiddlewareService } from './services/navigation-data-middleware.service';
import { SharedService } from './services/shared.service';
import { TokenService } from './services/token.service';
import { AnalyticsService } from './services/analytics.service';
import { GlobalErrorHandlerService } from './services/global-error-handler.service';
import { ToastrModule } from 'ngx-toastr';
import { CustomLoaderComponent } from './shared/components/custom-loader/custom-loader.component';
import { TranslateLabelsByEnviroment, MyMissingTranslationHandler } from './services/translation.service';
import { ImpersonateService } from './services/impersonate.service';
import { registerLocaleData } from '@angular/common';
import localeDa from '@angular/common/locales/da';
import localeSv from '@angular/common/locales/sv';

registerLocaleData(localeDa);
registerLocaleData(localeSv);

export function jwtOptionsFactory(cookieService) {
  return {
    tokenGetter: () => cookieService.get('AuthToken')
  };
}

export function tokenStartup(tokenService: TokenService) {
  return () => {
    tokenService.readTokenFromURL();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    TokenComponent,
    CustomLoaderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [CookieService]
      },
      config: {
        allowedDomains: ['localhost:8452', 'howdy.care']
      }
    }),
    AppRoutingModule,
    TranslateModule.forRoot({
      loader: TranslateLabelsByEnviroment,
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MyMissingTranslationHandler,
        deps: [Injector]
      }
    }),
    ToastrModule.forRoot({
      preventDuplicates: true
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    CookieService,
    AuthGuardService,
    TokenService,
    {
      provide: APP_INITIALIZER,
      useFactory: tokenStartup,
      deps: [TokenService, JwtHelperService, CookieService],
      multi: true,
    },
    ConfigStoreService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    SharedService,
    MenuService,
    NavigationDataMiddlewareService,
    AnalyticsService,
    ImpersonateService
  ]
})

export class AppModule { }
